import React, {useEffect} from 'react';
import Common from "./common";
import store from "../../storeWire";
import {setData} from "../../store/slice/customerAccount";
import axios from "axios";
import Helper from "../../application/helper";
import {usePage} from "@inertiajs/inertia-react";
import {
    CButton,
    CButtonGroup,
    CCard,
    CCardBody, CCardFooter,
    CCardText,
    CCardTitle,
    CCol, CContainer, CFormCheck,
    CFormFloating,
    CFormInput,
    CFormLabel, CFormTextarea, CInputGroup, CInputGroupText,
    CRow
} from "@coreui/react";

const Destroy = () => {
    const p = usePage();
    useEffect(() => {
        axios.get(Helper.route('customeraccount.show', {
            customeraccount: p.props.customer_account
        })).then((res) => {
            if (res.data.data.id !== undefined && res.data.data.id) {
                store.dispatch(setData(res.data.data));
            } else {
                window.location.href = Helper.route('customer-account.index');
            }
        }).catch(() => {
            window.location.href = Helper.route('customer-account.index');
        });
    }, []);
    return <>
        <CContainer fluid={true}>
            <CRow>
                <CCard className={'card text-white bg-danger'}>
                    <CCardBody>
                        <CCardTitle>Destroy Customer Account</CCardTitle>
                        <CCardText>
                            Press Destroy to remove this account, Remember this is non reversible Operation.
                        </CCardText>
                    </CCardBody>
                </CCard>
            </CRow>
        </CContainer>
        <Common/></>;
}

export default Destroy;
